import type { TFunction } from 'i18next';

export const createDateRangeString = (dateArray: Array<string | null>, t: TFunction): string => {
  const [startDate, endDate] = dateArray;

  if (startDate && endDate) {
    return `${startDate}-${endDate}`;
  }

  if (startDate) {
    return t('from {startDate}', { startDate });
  }

  if (endDate) {
    return t('to {endDate}', { endDate });
  }

  return '';
};
